module.exports = __webpack_public_path__ + "img/yiruntong3.df1170eb.svg";